module.exports = __webpack_public_path__ + "static/media/1.2 Servatius Helm klein.41c09c8c.jpg";